import { useNavigate } from "react-router-dom";
import { clearActiveAuth } from "../../utils/authSession";
function LogOut() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearActiveAuth();

    navigate("/");
  };

  return (
    <button
      onClick={handleLogout}
      className="text-white cursor-pointer font-bold rounded-lg transition"
      >
        Log Out
    </button>
  );
}

export default LogOut;
